import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import proptypes from '../utils/proptypes';

export const Skeleton = ({
  width,
  height,
  shape = 'rect',
  count = 1,
  className = '',
}) => {
  const skeletons = Array.from({ length: count }).map((_, index) => (
    <div
      key={index}
      className={cn(`skeleton ${shape} ${className}`)}
      style={{ width, height }}
    />
  ));

  return <>{skeletons}</>
};

Skeleton.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
};

Skeleton.defaultProps = {
  className: '',
  width: '150px',
  height: '20px',
  count: 3,
};
